import Vue from 'vue';
import App from './App.vue';
import Toasted from 'vue-toasted';
import VueNumber from 'vue-number-animation';
import { register, getI18n } from './I18n';

import * as $ from 'jquery';
import 'bootstrap';

window.$ = window.jQuery = $;

Vue.use(Toasted as any); // TODO: Fix typings in module
Vue.config.productionTip = false;

Vue.use(VueNumber);

const lang = {
  pref: localStorage.getItem('lang'),
  browser: (navigator.language || navigator.language).substring(0, 2),
};

console.log(lang);
const langCallback = register(Vue, lang.pref || lang.browser);

new Vue({
  render: (h) => h(App, {
    props: {
      languageCallback: langCallback
    }
  }),
  i18n: getI18n(),
}).$mount('#app');
